import { Grid } from "@mui/material";
import { FC } from "react";

import { WalletItem } from "../../interfaces";
import { Text } from "../Text/Text";

export const WalletOption: FC<{ wallet: WalletItem }> = ({ wallet }) => {
  return (
    <Grid spacing={1} alignItems="center" container>
      <Grid item>{wallet.logo}</Grid>
      <Grid item>
        <Text text={wallet.name} />
      </Grid>
    </Grid>
  );
};
